import { handleActions } from 'redux-actions';
import Immutable, { set } from 'seamless-immutable';

import { WIDGET_WORKING, WIDGET_FINISHED } from './actions';

export const INITIAL_STATE = Immutable({});

export const actionMap = {
  [WIDGET_WORKING]: (state) => set(state, 'working', true),
  [WIDGET_FINISHED]: (state) => set(state, 'working', false),
};

export default handleActions(actionMap, INITIAL_STATE);
